import request from 'api/requestUtils'
import qs from 'qs'

interface FlightAirportsResponse {
  status: number
  message: null
  result: {
    flightsIncluded: boolean
    arrivalAirportCode: string | null
    departureAirportCode: string | null
  }
}

export default async function getTourFlightAirports(tourId: string, departureId: string): Promise<App.Tours.FlightAirports> {
  const query = qs.stringify({ departureId })
  const response = await request.get<FlightAirportsResponse>(`/api/v2/tours/${encodeURIComponent(tourId)}/flight-airports?${query}`)
  return {
    flightsIncluded: response.result.flightsIncluded,
    arrivalAirportCode: response.result.arrivalAirportCode ?? undefined,
    departureAirportCode: response.result.departureAirportCode ?? undefined,
  }
}
